import { render, staticRenderFns } from "./addExchangePurchase.vue?vue&type=template&id=728d767c"
import script from "./addExchangePurchase.vue?vue&type=script&lang=js"
export * from "./addExchangePurchase.vue?vue&type=script&lang=js"
import style0 from "./addExchangePurchase.vue?vue&type=style&index=0&id=728d767c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports